import { render, staticRenderFns } from "./Libraries.vue?vue&type=template&id=2977e700&"
import script from "./Libraries.vue?vue&type=script&lang=js&"
export * from "./Libraries.vue?vue&type=script&lang=js&"
import style0 from "./Libraries.vue?vue&type=style&index=0&id=2977e700&prod&scroped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports